<template>
    <div class="none"/>
</template>

<script setup lang="ts">
/**
 * This is a simple hidden input to manually set a form's validation state to false via a value.
 */
import {parseBoolean} from "@spoferan/spoferan-ts-core";
import {TextInputComponentEmits} from "../../../composables/useTextInputComponent";
import {computed} from "vue";
import {useI18n} from "#imports";
import {type InputComponentProps, useInputComponent} from "../../../composables/useInputComponent";

const {t} = useI18n();
const props = defineProps<InputComponentProps>();
const emit = defineEmits(TextInputComponentEmits);

const {} = useInputComponent(props, emit, {
  baseValidationRules: computed(() => {
    return {
      custom: (value) => {
        return parseBoolean(value) || (props.error ?? t('validation.check_inputs'))
      }
    }
  })
});

</script>
